<template>
  <div>
    <div class="VV_DocumentRow d-flex py-2">
      <div class="mr-4"
           v-if="showImages">
        <document-thumbnail :connection="connection"
                            :document="document"
                            @click.prevent="dialog = true">
        </document-thumbnail>
      </div>
      <div class="flex-grow-1">
        <div>
          <file-type-icon :document="document"
                          class="mr-2">
          </file-type-icon>
          <a href="#"
             @click.prevent="dialog = true">
            <template v-if="showVersion">
              {{ name }} {{ version }}
            </template>
            <template v-else>
              {{ name }}
            </template>
          </a>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div>
            123456789
          </div>
          <div class="mx-1">
            &mdash;
          </div>
          <div>
            {{ title }}
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div class="text-nowrap">
            {{ document.document_number__v }}
          </div>
          <div class="mx-1">
            &mdash;
          </div>
          <div>
            {{ title }}
          </div>
        </div>
        <div v-if="isDemo"
             class="d-flex text-caption">
          <div class="text-nowrap">
            Type
          </div>
          <div class="ml-1">
            > Subtype
          </div>
          <div class="ml-1">
            > Classification
          </div>
        </div>
        <div v-else
             class="d-flex text-caption">
          <div>
            {{ document.type__v }}
          </div>
          <div class="ml-1"
               v-if="document.subtype__v">
            > {{ document.subtype__v }}
          </div>
          <div class="ml-1"
               v-if="document.classification__v">
            > {{ document.classification__v }}
          </div>

        </div>
      </div>
      <div>
        <div class="text-caption">
          <div class="text-right text-no-wrap">
            {{ document.status__v }}
          </div>
          <div v-if="document.expiration_date"
               class="text-right text-nowrap">
            Expires: {{ document.expiration_date | datetime('MMM D, YYYY') }}
          </div>
          <div v-else-if="document.expiration_date__c"
               class="text-right text-nowrap">
            Expires: {{ document.expiration_date__c | datetime('MMM D, YYYY') }}
          </div>
          <div v-else-if="document.expiration_date1__c"
               class="text-right text-nowrap">
            Expires: {{ document.expiration_date1__c | datetime('MMM D, YYYY') }}
          </div>
          <div v-else
               class="text-right text-nowrap">
            No expiration date
          </div>
        </div>
        <div>
          <div class="mt-1">
            <v-btn @click.prevent="addToCart"
                   v-if="!inCart"
                   x-small
                   block
                   color="primary">
              Add to cart
            </v-btn>
            <v-btn @click.prevent="removeFromCart"
                   v-else
                   x-small
                   block
                   color="primary">
              Remove from cart
            </v-btn>

            <v-btn v-if="1===2"
                   :href="downloadURL"
                   target="_blank"
                   x-small
                   block
                   :disabled="!canDownload">
              Download
            </v-btn>

            <v-btn type="button"
                   x-small
                   block
                   @click.prevent="expanded = !expanded"
                   class="mt-2">
              {{ expanded ? 'Hide' : 'Expand' }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div v-if="expanded">
      <pre>{{ document }}</pre>
    </div>

    <v-dialog v-model="dialog"
              class="VV_DocumentDialog"
              width="90%">
      <v-card class="VV_DocumentDialogCard">
        <v-card-title>

        </v-card-title>
        <v-card-text>
          <codemirror-json :code="JSON.stringify(document, null, 2)"
                           :options="{lineNumbers: true, lineWrapping: true, mode: 'javascript', readOnly: true, theme: 'monokai'}">
          </codemirror-json>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="scss">
.VV_DocumentDialogCard {
  .CodeMirror {
    height: 500px;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import DocumentThumbnail from './DocumentThumbnail';
import FileTypeIcon from './FileTypeIcon';
import veevaVaultService from '../../../services/veevaVaultService';
import CodemirrorJson from './CodeMirrorJson';

export default {
  components: {CodemirrorJson, FileTypeIcon, DocumentThumbnail},
  props: {
    connection: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    showImages: {
      type: Boolean,
      default: false,
    },
    showVersion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      expanded: false,
    }
  },
  computed: {
    ...mapGetters('vaultCart', [
      'documents',
    ]),
    ...mapGetters('veevaVault', [
      'connections',
    ]),
    isDemo() { // MLD-2944
      return this.connection === 'demo_vault';
    },
    inCart() {
      const doc = find(this.documents, d => d.id === this.document.id);
      return !!doc;
    },
    version() {
      return `(v${this.document.major_version_number__v}.${this.document.minor_version_number__v})`
    },
    name() {
      if (this.document.name__v && this.isDemo) { // MLD-2944
        return `*********************${this.document.name__v.slice(this.document.name__v.length - 4)}`
      }
      return this.document.name__v;
    },
    title() { // MLD-2944
      if (this.isDemo) {
        if (this.document.title__v) {
          return `*********************${this.document.title__v.slice(this.document.title__v.length - 4)}`
        } else if (this.document.name__v) {
          return `*********************${this.document.name__v.slice(this.document.name__v.length - 4)}`
        } else {
          return `*********************`;
        }
      }
      return this.document.name__v;
    },
    titleOrName() {
      return this.document.title__v
        ? this.document.title__v
        : this.document.name__v;
    },
    expirationDate() {
      if (this.document.expiration_date1__c) {

      }
      return null;
    },
    isApproved() {
      return ['Approved for Use', 'Approved for Distribution'].includes(this.document.status__v);
    },
    canDownload() {
      return this.isApproved;
    },
    downloadURL() {
      return `/proxy/veeva/vault/objects/documents/${this.document.id}/file`
    }
  },
  methods: {
    toggleCart() {
      if (this.inCart) {
        this.removeFromCart();
      } else {
        this.addToCart();
      }
    },
    addToCart() {
      this.$store.dispatch('vaultCart/addDocument', this.document);
    },
    removeFromCart() {
      this.$store.dispatch('vaultCart/removeDocument', this.document);
    },
    download() {
      veevaVaultService.downloadDocument(this.connection, this.document.id);
    }
  }
}
</script>
